import { render, staticRenderFns } from "./IntermediaryCampaignReview.vue?vue&type=template&id=2ea58c04&"
import script from "./IntermediaryCampaignReview.vue?vue&type=script&lang=js&"
export * from "./IntermediaryCampaignReview.vue?vue&type=script&lang=js&"
import style0 from "./IntermediaryCampaignReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IntermediaryCampaignReview.vue"
export default component.exports